(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["clearpay-product-messaging"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__clearpayPdpSlotLock) return;
    window.__clearpayPdpSlotLock = true;

    const slots = () => document.querySelectorAll('[data-clearpay-slot]:not([data-clearpay-lock-bound])');

    function lockSlot(slot) {
      slot.dataset.clearpayLockBound = '1';
      let maxHeight = 0;

      const reserve = (height) => {
        if (height <= maxHeight) return;
        maxHeight = height;
        slot.style.setProperty('--clearpay-pdp-slot-height', `${Math.ceil(height)}px`);
      };

      const readPlacement = () => {
        const mount = slot.querySelector('.clearpay-product-messaging');
        const placement = mount?.nextElementSibling;
        if (!placement?.matches?.('square-placement')) return null;
        return placement;
      };

      const sync = () => {
        const placement = readPlacement();
        if (!placement) return;
        const height = placement.getBoundingClientRect().height;
        if (height > 0) reserve(height);
      };

      const bindPlacement = () => {
        const placement = readPlacement();
        if (!placement) return false;
        new ResizeObserver(sync).observe(placement);
        sync();
        return true;
      };

      if (!bindPlacement()) {
        const mo = new MutationObserver(() => {
          if (bindPlacement()) mo.disconnect();
        });
        mo.observe(slot, { childList: true });
      }

      window.addEventListener('Square.Marketplace.ready', sync);
    }

    const scan = () => slots().forEach(lockSlot);
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
